module.exports = __webpack_public_path__ + "static/media/slide-3.a1a4865e.svg";